// @flow
import React, { Component } from "react";
import { Table, DatePicker, Select, Button } from "antd";
import { Row, Col, PageHeader } from "antd";

import PropTypes from "prop-types";
import accounting from "accounting";

import moment from "moment";
import "moment/locale/ru";

const { RangePicker } = DatePicker;
const Option = Select.Option;

class DataList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    const {
      loading,
      report,
      fetchParams,
      period,
      onChangeDateRange,
      onChangePeriod,
    } = this.props;

    const dateFormat = "DD.MM.YYYY";
    let totals = []
    let data = []

    if (report.length > 0) {
      let orders_total = report.reduce(
        (sum, record) => sum + Number(record.orders_qty),
        0
      );
      let invoices_total = report.reduce(
        (sum, record) => sum + Number(record.invoices_qty),
        0
      );

      let proposals_total = report.reduce(
        (sum, record) => sum + Number(record.proposals_qty),
        0
      );

      let shipments_total = report.reduce(
        (sum, record) => sum + Number(record.shipments_qty),
        0
      );

      totals.push({
        id: 999,
        name: "Итого",
        orders_qty: orders_total,
        invoices_qty: invoices_total,
        proposals_qty: proposals_total,
        shipments_qty: shipments_total,
      });

      data = report.concat(totals);
    }

    const columns = [
      {
        title: "Ответсвенный",
        dataIndex: "name",
        align: "left",
        width: "25%",
      },
      {
        title: "Заказы (кол-во)",
        dataIndex: "orders_qty",
        align: "right",
        width: "15%",
      },
      {
        title: "Счета (кол-во)",
        dataIndex: "invoices_qty",
        align: "right",
        width: "15%",
      },
      {
        title: "Заявки (кол-во)",
        dataIndex: "proposals_qty",
        align: "right",
        width: "15%",
      },
      {
        title: "Отгрузки (кол-во)",
        dataIndex: "shipments_qty",
        align: "right",
        width: "15%",
      },
      {
        title: "Итого",
        dataIndex: "total",
        render: (total, record) =>
          record.orders_qty +
          record.invoices_qty +
          record.proposals_qty +
          record.shipments_qty,
        align: "right",
        width: "15%",
      },
    ];

    return (
      <PageHeader
        onBack={() => window.history.back()}
        title={`Статистика по менеджерам c ${fetchParams.startDate} по ${fetchParams.endDate}`}
        footer={
          <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
            <Col span={24} style={{ paddingBottom: "15px" }}>
              <Table
                bordered
                size={"small"}
                loading={loading}
                pagination={false}
                columns={columns}
                dataSource={data}
                rowKey="id"
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <RangePicker
              style={{ width: "100%" }}
              value={[
                moment(fetchParams.startDate, dateFormat),
                moment(fetchParams.endDate, dateFormat),
              ]}
              format={dateFormat}
              onChange={onChangeDateRange}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <Select
              style={{ width: "100%" }}
              value={period}
              placeholder="Период"
              optionFilterProp="children"
              filterOption={false}
              onChange={onChangePeriod}
            >
              <Option value={0}>произвольный период</Option>
              <Option value={1}>этот месяц</Option>
              <Option value={2}>этот квартал</Option>
              <Option value={3}>этот год</Option>
              <Option value={4}>прошлый месяц</Option>
              <Option value={5}>прошлый квартал</Option>
              <Option value={6}>прошлый год</Option>
            </Select>
          </Col>
        </Row>
      </PageHeader>
    );
  }
}

DataList.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.object,
  fetchParams: PropTypes.object,
};

export default DataList;
